import { defineMessages } from 'react-intl';

export default defineMessages({
  signIn: {
    id: 'widget.account.sign-in',
    defaultMessage: 'Sign in',
  },
  signInToComplete1: {
    id: 'widget.account.sign-in-to-complete.part-1',
    defaultMessage: 'Sign up to complete',
  },
  signInToComplete2: {
    id: 'widget.account.sign-in-to-complete.part-2',
    defaultMessage: 'your purchase',
  },
  signInToWatch1: {
    id: 'widget.account.sign-in-to-watch.part-1',
    defaultMessage: 'Sign up to watch this video.',
  },
  signInToWatch2: {
    id: 'widget.account.sign-in-to-watch.part-2',
    defaultMessage: 'It\'ll only take a sec.',
  },
  signUp: {
    id: 'widget.account.sign-up',
    defaultMessage: 'Sign up',
  },
  logout: {
    id: 'widget.account.logout',
    defaultMessage: 'Log out',
  },
  forgotPassword: {
    id: 'widget.account.forgot-password',
    defaultMessage: 'Forgot Password',
  },
  email: {
    id: 'widget.account.email',
    defaultMessage: 'Email',
  },
  password: {
    id: 'widget.account.password',
    defaultMessage: 'Password',
  },
  notHaveAccount: {
    id: 'widget.account.not-have-account',
    defaultMessage: 'Don’t have an account?',
  },
  haveAccount: {
    id: 'widget.account.have-account',
    defaultMessage: 'Already have an account?',
  },
  forgotPasswordQuestion: {
    id: 'widget.account.forgot-password.question',
    defaultMessage: 'Forgot password?',
  },
  forgotPasswordMessage1: {
    id: 'widget.account.forgot-password.message1',
    defaultMessage: 'Fill in the email address you signed up with and we will email you a reset link.',
  },
  forgotPasswordMessage2: {
    id: 'widget.account.forgot-password.message2',
    defaultMessage: 'No worries, everything will be here when you return to complete you purchase.',
  },
  forgotPasswordSubmitted1: {
    id: 'widget.account.forgot-password.submitted1',
    defaultMessage: 'We’ve emailed a link to reset your password to "{email}".',
  },
  forgotPasswordSubmitted2: {
    id: 'widget.account.forgot-password.submitted2',
    defaultMessage: 'We’ll be snacking some popcorn until you are done.',
  },
  gotIt: {
    id: 'widget.account.forgot-password.got-it',
    defaultMessage: 'Got it!',
  },
  back: {
    id: 'widget.account.back',
    defaultMessage: 'Back',
  },
  backToSignIn: {
    id: 'widget.account.back-to-sign-in',
    defaultMessage: 'Back to sign in',
  },
  sendLink: {
    id: 'widget.account.send-link',
    defaultMessage: 'Send me a link',
  },
  resetPassword: {
    id: 'widget.account.reset-password',
    defaultMessage: 'Reset Password',
  },
  resetPasswordMessage: {
    id: 'widget.account.reset-password.linkText',
    defaultMessage: 'To set your new password, please enter it in both fields below.',
  },
  resetPasswordButton: {
    id: 'widget.account.reset-password.button',
    defaultMessage: 'Reset password',
  },
  enterNewPassword: {
    id: 'widget.account.reset-password.enter-new-password',
    defaultMessage: 'Enter a new password',
  },
  verifyPassword: {
    id: 'widget.account.reset-password.verify-password',
    defaultMessage: 'Verify password',
  },
  resetComplete: {
    id: 'widget.account.reset-password.complete',
    defaultMessage: 'You’ve successfully reset your password!',
  },
  continueToSite: {
    id: 'widget.account.reset-password.continue-to-site',
    defaultMessage: 'Continue to site',
  },
  readyAction: {
    id: 'widget.account.ready-action',
    defaultMessage: 'Proceed to Checkout',
  },
  signedAs: {
    id: 'widget.account.signed-as',
    defaultMessage: 'You are signed in as:',
  },
  notYourAccount: {
    id: 'widget.account.not-your-account',
    defaultMessage: 'Not your account?',
  },
  modalTitle: {
    id: 'widget.account.modal-title',
    defaultMessage: 'Account info',
  },
  modalClose: {
    id: 'widget.account.modal-close',
    defaultMessage: 'Close account info',
  },
  errorLabel: {
    id: 'cashier.error.a11y.label',
    defaultMessage: 'Error message',
  },
  errorDefault: {
    id: 'cashier.error.default',
    defaultMessage: 'Something went wrong',
  },
  errorPayment: {
    id: 'cashier.error.payment',
    defaultMessage: 'Please contact us to complete your purchase. Thank you.',
  },
  errorRetryText: {
    id: 'cashier.error.retry-text',
    defaultMessage: 'Reload to try again',
  },
  errorRetryButton: {
    id: 'cashier.error.retry-button',
    defaultMessage: 'Reload',
  },
  'error.no_payment_methods': {
    id: 'cashier.errorMessages.no_payment_methods',
    defaultMessage: 'We\'re not able to accept online payments',
  },
  allCategories: {
    id: 'widget.categories.all-videos',
    defaultMessage: 'All Categories',
  },
  subscribe: {
    id: 'widget.channel-actions.subscribe',
    defaultMessage: 'Subscribe {price}/month',
  },
  proceedCheckout: {
    id: 'widget.payments.proceed-checkout',
    defaultMessage: 'Proceed to Checkout',
  },
  proceedPaypal: {
    id: 'widget.payments.proceed-paypal',
    defaultMessage: 'Proceed with PayPal',
  },
  subscriptionMonth: {
    id: 'widget.payments.subscription-month',
    defaultMessage: 'Subscription {price}/month',
  },
  purchase: {
    id: 'widget.payments.purchase',
    defaultMessage: 'Purchase {price}',
  },
  rent: {
    id: 'widget.payments.rent',
    defaultMessage: 'Rent {price}',
  },
  singleVideoStreaming: {
    id: 'widget.payments.single-video-streaming',
    defaultMessage: '1 video streaming',
  },
  streamingPeriod: {
    id: 'widget.payments.streaming-period',
    defaultMessage: '{period} hours streaming period starts when you hit the "play" button',
  },
  singleVideo: {
    id: 'widget.payments.single-video',
    defaultMessage: '1 video',
  },
  onePayment: {
    id: 'widget.payments.one-payment',
    defaultMessage: 'One time payment',
  },
  unlimitedStreaming: {
    id: 'widget.payments.unlimitedStreaming',
    defaultMessage: 'Unlimited streaming',
  },
  instantAccess: {
    id: 'widget.payments.instant-access',
    defaultMessage: 'Instant access to new videos',
  },
  monthlyPayment: {
    id: 'widget.payments.monthly-payment',
    defaultMessage: 'Recurring monthly payments (cancel anytime)',
  },
  paymentSubscribeToChannel: {
    id: 'widget.payments.subscribe-to-channel',
    defaultMessage: 'Subscribe to channel',
  },
  cancelSubscription: {
    id: 'widget.payments.cancel-subscription',
    defaultMessage: 'Cancel subscription',
  },
  subscribedSince: {
    id: 'widget.payments.subscribed-since',
    defaultMessage: 'Subscribed since {date}. {price}/month',
  },
  memberOnlyBenefits: {
    id: 'widget.payments.member-only-benefits',
    defaultMessage: 'Here\'s what you\'ll get:',
  },
  confirmAndPay: {
    id: 'widget.payments.confirm-and-pay',
    defaultMessage: 'Confirm and Pay',
  },
  retry: {
    id: 'widget.payments.reload-button',
    defaultMessage: 'Reload',
  },
  paymentsBack: {
    id: 'widget.payments.back-button',
    defaultMessage: 'Back',
  },
  viewChannel: {
    id: 'widget.mobile.overlay-button.visit-channel',
    defaultMessage: 'Visit channel',
  },
  mobileSignIn: {
    id: 'widget.mobile.overlay-button.sign-in',
    defaultMessage: 'Sign in',
  },
  subscribeShortText: {
    id: 'widget.mobile.overlay-button.subscribe.short',
    defaultMessage: 'Subscribe',
  },
  previewMode: {
    id: 'widget.preview-prompt.preview-mode',
    defaultMessage: 'Preview Mode',
  },
  youInPreview1: {
    id: 'widget.preview-prompt.you-in-preview.line1',
    defaultMessage: 'Hey, you’re in Preview mode.',
  },
  youInPreview2: {
    id: 'widget.preview-prompt.you-in-preview.line2',
    defaultMessage: 'This feature works on your live site once it’s published.',
  },
  previewGotIt: {
    id: 'widget.preview-prompt.got-it',
    defaultMessage: 'Got it!',
  },
  searchVideo: {
    id: 'widget.search-bar.search-video',
    defaultMessage: 'Search video...',
  },
  nowPlaying: {
    id: 'thumbnail.now-playing',
    defaultMessage: 'Now Playing',
  },
  embedTitle: {
    id: 'share-overlay.embed.video.title',
    defaultMessage: 'Embed Video',
  },
  embedCopy: {
    id: 'share-overlay.embed.copy',
    defaultMessage: 'Copy',
  },
  custom: {
    id: 'share-overlay.embed.custom',
    defaultMessage: 'Custom',
  },
  shareChannelOrVideo: {
    id: 'share-overlay.social.title',
    defaultMessage: 'Share',
  },
  shareWholeChannel: {
    id: 'share-overlay.social.share-channel',
    defaultMessage: 'Whole Channel',
  },
  shareThisVideo: {
    id: 'share-overlay.social.share',
    defaultMessage: 'Share this video',
  },
  desktopShareVideo: {
    id: 'share-overlay.social.share-video',
    defaultMessage: 'This Video',
  },
  linkCopied: {
    id: 'share-overlay.social.link-copied',
    defaultMessage: 'Link Copied',
  },
  embedVideo: {
    id: 'share-overlay.social.embed-video',
    defaultMessage: 'Embed Video',
  },
  copyLink: {
    id: 'share-overlay.social.copy-link',
    defaultMessage: 'Copy Link',
  },

  shareButtonTooltip: {
    id: 'widget.compact-view.components.action-bar.share-tooltip-button',
    defaultMessage: 'Share',
  },
  shareThisChannel: {
    id: 'widget.compact-view.components.action-bar.share-this-channel',
    defaultMessage: 'Share this Channel',
  },
  channelInfoTooltip: {
    id: 'widget.compact-view.components.action-bar.channel-info-tooltip',
    defaultMessage: 'Channel Info',
  },
  close: {
    id: 'widget.compact-view.components.action-bar.close',
    defaultMessage: 'Close',
  },
  allVideos: {
    id: 'widget.strip-view.all-videos',
    defaultMessage: 'All Videos',
  },
  closeStrip: {
    id: 'widget.strip-view.close',
    defaultMessage: 'Close',
  },
  videoNotAvailable: {
    id: 'widget.video-is-not-available',
    defaultMessage: 'This video isn\'t available right now.',
  },
  checkAgainLater: {
    id: 'widget.check-again-later',
    defaultMessage: 'Check again later',
  },
  publisher: {
    id: 'player.info-overlay.created-by',
    defaultMessage: 'By {author}',
  },
  cast: {
    id: 'player.info-overlay.cast',
    defaultMessage: 'cast',
  },
  crew: {
    id: 'player.info-overlay.crew',
    defaultMessage: 'crew',
  },
  facebook: {
    id: 'social-button.facebook',
    defaultMessage: 'Facebook',
  },
  twitter: {
    id: 'social-button.twitter',
    defaultMessage: 'Twitter',
  },
  pinterest: {
    id: 'social-button.pinterest',
    defaultMessage: 'Pinterest',
  },
  tumblr: {
    id: 'social-button.tumblr',
    defaultMessage: 'Tumblr',
  },
  link: {
    id: 'social-button.link',
    defaultMessage: 'Link',
  },
  copy: {
    id: 'social-button.copy',
    defaultMessage: 'Copy',
  },
  twitterDescription: {
    id: 'social-share.network.twitter',
    defaultMessage: 'Watch "{title}" on {siteUrl}',
  },
  pinterestDescription: {
    id: 'social-share.network.pinterest',
    defaultMessage: '{title} - {description}',
  },
  tumblrDescription: {
    id: 'social-share.network.tumblr',
    defaultMessage: '{title} - {siteUrl}',
  },
  watchNext: {
    id: 'widget.video-cards.watch-next',
    defaultMessage: 'Watch Next',
  },
  watchLive: {
    id: 'widget.video-cards.watch-live',
    defaultMessage: 'Watch Live',
  },
  watchMore: {
    id: 'widget.video-cards.watch-more',
    defaultMessage: 'Watch More',
  },
  live: {
    id: 'widget.video-cards.live-label',
    defaultMessage: 'live',
  },
  prevVideo: {
    id: 'widget.accessibility.prev-video',
    defaultMessage: 'Previous video',
  },
  nextVideo: {
    id: 'widget.accessibility.next-video',
    defaultMessage: 'Next video',
  },
  prevVideos: {
    id: 'widget.accessibility.prev-videos',
    defaultMessage: 'Previous videos',
  },
  nextVideos: {
    id: 'widget.accessibility.next-videos',
    defaultMessage: 'Next videos',
  },
  closeVideoList: {
    id: 'widget.accessibility.close-video-list',
    defaultMessage: 'Close video list',
  },
  closeExpandedView: {
    id: 'widget.accessibility.close-expanded-view',
    defaultMessage: 'Close expanded view',
  },
  selectCategory: {
    id: 'widget.accessibility.select-category',
    defaultMessage: 'Select a category',
  },
  searchVideos: {
    id: 'widget.accessibility.search-videos',
    defaultMessage: 'Search videos',
  },
  closeVideosSearch: {
    id: 'widget.accessibility.close-videos-search',
    defaultMessage: 'Close videos search',
  },
  showVideoInfo: {
    id: 'widget.accessibility.show-video-info',
    defaultMessage: 'Show Video info',
  },
  closeVideoInfo: {
    id: 'widget.accessibility.close-video-info',
    defaultMessage: 'Close Video info',
  },
  showChannelInfo: {
    id: 'widget.accessibility.show-channel-info',
    defaultMessage: 'Show Channel info',
  },
  closeChannelInfo: {
    id: 'widget.accessibility.close-channel-info',
    defaultMessage: 'Close Channel info',
  },
  subscribeToChannel: {
    id: 'widget.accessibility.subscribe-to-channel',
    defaultMessage: 'Subscribe to channel',
  },
  closePurchaseInfo: {
    id: 'widget.accessibility.close-purchase-info',
    defaultMessage: 'Close Purchase info',
  },
  allCards: {
    id: 'widget.accessibility.all-cards',
    defaultMessage: 'All cards',
  },
  share: {
    id: 'widget.accessibility.share',
    defaultMessage: 'Share',
  },
  closeShare: {
    id: 'widget.accessibility.close-share',
    defaultMessage: 'Close Share',
  },
  shareOn: {
    id: 'widget.accessibility.share-on',
    defaultMessage: 'Share on {network}',
  },
  getLink: {
    id: 'widget.accessibility.get-link',
    defaultMessage: 'Get a link',
  },
  getEmbedCode: {
    id: 'widget.accessibility.get-embed-code',
    defaultMessage: 'Get embed code',
  },
  closeEmbedForm: {
    id: 'widget.accessibility.close-embed-form',
    defaultMessage: 'Close embed form',
  },
  showMore: {
    id: 'widget.accessibility.show-more',
    defaultMessage: 'Show more',
  },
  myAccount: {
    id: 'widget.accessibility.my-account',
    defaultMessage: 'My Account',
  },
  closeAccountInfo: {
    id: 'widget.accessibility.close-account-info',
    defaultMessage: 'Close Account info',
  },
  channelVideos: {
    id: 'widget.accessibility.channel-videos',
    defaultMessage: '"{channelTitle}" channel videos',
  },
  channelVideosPageN: {
    id: 'widget.accessibility.channel-videos-page-n',
    defaultMessage: '"{channelTitle}" channel videos - page {pageNumber}',
  },
  searchResultsFor: {
    id: 'widget.accessibility.search-results-for',
    defaultMessage: 'Search results for "{searchQuery}"',
  },
  searchResultsPageNFor: {
    id: 'widget.accessibility.search-results-page-n-for',
    defaultMessage: 'Search results for "{searchQuery}" - page {pageNumber}',
  },
  showAllVideos: {
    id: 'widget.accessibility.show-all-videos',
    defaultMessage: 'Show all videos',
  },
  duration: {
    id: 'widget.accessibility.duration',
    defaultMessage: 'Duration {durationStr}',
  },
  widgetSize: {
    id: 'widget.accessibility.widget-size',
    defaultMessage: 'Widget size {size}',
  },
  customWidgetSize: {
    id: 'widget.accessibility.custom-widget-size',
    defaultMessage: 'Custom widget size',
  },
  widgetWidth: {
    id: 'widget.accessibility.widget-width',
    defaultMessage: 'Widget width {width}',
  },
  widgetHeight: {
    id: 'widget.accessibility.widget-height',
    defaultMessage: 'Widget height {height}',
  },
  channelVideosWidget: {
    id: 'widget.accessibility.channel-videos-widget',
    defaultMessage: '"{channelTitle}" channel videos widget',
  },
  slideToNextActionCard: {
    id: 'widget.accessibility.action-cards.all-cards.previous-page',
    defaultMessage: 'Next Action Card',
  },
  slideToPrevActionCard: {
    id: 'widget.accessibility.action-cards.all-cards.next-page',
    defaultMessage: 'Previous Action Card',
  },
  allCardsSlideContents: {
    id: 'widget.accessibility.action-cards.all-cards.slide-contents',
    defaultMessage: 'Slide with {itemsCount} Action Cards',
  },
  likeThisPageOnFacebook: {
    id: 'widget.accessibility.action-cards.facebook-like-button',
    defaultMessage: 'Facebook Like Button',
  },
  subscribeToYoutubeChannel: {
    id: 'widget.accessibility.action-cards.youtube-subscribe-button',
    defaultMessage: 'Youtube Subscribe Button',
  },
  followOnTwitter: {
    id: 'widget.accessibility.action-cards.twitter-follow-button',
    defaultMessage: 'Twitter Follow Button',
  },
  noSearchResults: {
    id: 'widget.home-view.no-search-results',
    defaultMessage: 'No search results',
  },
  thisChannelIsComingSoon: {
    id: 'widget.this-channel-is-coming-soon',
    defaultMessage: 'This channel is coming soon!',
  },
  watchOnSiteLabel: {
    id: 'widget.player.watch-on-site-label',
    defaultMessage: 'Watch On Site',
  },
  watchOnSiteTooltip: {
    id: 'widget.player.watch-on-site-tooltip',
    defaultMessage: 'Watch On Site',
  },
  pauseControlLabel: {
    id: 'widget.player.pause-control-label',
    defaultMessage: 'Pause',
  },
  playControlLabel: {
    id: 'widget.player.play-control-label',
    defaultMessage: 'Play',
  },
  progressControlLabel: {
    id: 'widget.player.progress-control-label',
    defaultMessage: 'Progress control',
  },
  progressControlValue: {
    id: 'widget.player.progress-control-value',
    defaultMessage: 'Already played {percent}%',
  },
  muteControlLabel: {
    id: 'widget.player.mute-control-label',
    defaultMessage: 'Mute',
  },
  muteControlTooltip: {
    id: 'widget.player.mute-control-tooltip',
    defaultMessage: 'Mute',
  },
  unmuteControlLabel: {
    id: 'widget.player.unmute-control-label',
    defaultMessage: 'Unmute',
  },
  unmuteControlTooltip: {
    id: 'widget.player.unmute-control-tooltip',
    defaultMessage: 'Unmute',
  },
  volumeControlLabel: {
    id: 'widget.player.volume-control-label',
    defaultMessage: 'Volume control',
  },
  volumeControlValue: {
    id: 'widget.player.volume-control-value',
    defaultMessage: 'Volume is {percent}%',
  },
  enterFullScreenLabel: {
    id: 'widget.player.enter-full-screen-label',
    defaultMessage: 'Enter full screen mode',
  },
  enterFullScreenTooltip: {
    id: 'widget.player.enter-full-screen-tooltip',
    defaultMessage: 'Enter full screen mode',
  },
  exitFullScreenLabel: {
    id: 'widget.player.exit-full-screen-label',
    defaultMessage: 'Exit full screen mode',
  },
  exitFullScreenTooltip: {
    id: 'widget.player.exit-full-screen-tooltip',
    defaultMessage: 'Exit full screen mode',
  },
  liveIndicator: {
    id: 'widget.player.live-indicator',
    defaultMessage: 'Live',
  },
  liveEndedIndicator: {
    id: 'widget.player.live-ended-indicator',
    defaultMessage: 'Live Ended',
  },
  liveSyncLabel: {
    id: 'widget.player.live-sync-label',
    defaultMessage: 'Sync to Live',
  },
  liveSyncTooltip: {
    id: 'widget.player.live-sync-tooltip',
    defaultMessage: 'Sync to Live',
  },
  lightboxCast: {
    id: 'lightbox.video-info.cast',
    defaultMessage: 'cast',
  },
  lightboxCrew: {
    id: 'lightbox.video-info.crew',
    defaultMessage: 'crew',
  },
  shareVideo: {
    id: 'widget.share-video.share',
    defaultMessage: 'Share Video',
  },
  shareVideoLink: {
    id: 'widget.share-video.share-link',
    defaultMessage: 'Video URL',
  },
  shareChannel: {
    id: 'widget.share-channel.share',
    defaultMessage: 'Share Channel',
  },
  shareChannelLink: {
    id: 'widget.share-channel.share-link',
    defaultMessage: 'Channel URL',
  },
  mobilePublisher: {
    id: 'mobile.video-list.publisher',
    defaultMessage: 'Published by {publisher}',
  },
  mobileYouOwnThis: {
    id: 'widget.vertical-video-list-mobile.youOwnThis',
    defaultMessage: 'You own this',
  },
  backButton: {
    id: 'mobile-overlay.page-header.back-button',
    defaultMessage: 'Back',
  },
  inputLabel: {
    id: 'mobile-overlay.channel.input-label',
    defaultMessage: 'Select a category',
  },
  mobileAllCategories: {
    id: 'mobile-overlay.channel.all-categories',
    defaultMessage: 'All Categories',
  },
  noDescription: {
    id: 'mobile-overlay.channel.about.no-description',
    defaultMessage: 'This channel has no description',
  },
  noTags: {
    id: 'mobile-overlay.channel.tagsTab.no-tags',
    defaultMessage: 'This channel has no tags',
  },
  videosTab: {
    id: 'mobile-overlay.channel.videosTab',
    defaultMessage: 'Videos',
  },
  tagsTab: {
    id: 'mobile-overlay.channel.tagsTab',
    defaultMessage: 'Tags',
  },
  infoTab: {
    id: 'mobile-overlay.channel.infoTab',
    defaultMessage: 'Info',
  },
  placeholder: {
    id: 'mobile-overlay.search.placeholder',
    defaultMessage: 'Search...',
  },
  mobileInputLabel: {
    id: 'mobile-overlay.search.input-label',
    defaultMessage: 'Search',
  },
  submitLabel: {
    id: 'mobile-overlay.search.submit-label',
    defaultMessage: 'Search',
  },
  clearLabel: {
    id: 'mobile-overlay.search.clear-label',
    defaultMessage: 'Clear search',
  },
  viewTitle: {
    id: 'mobile-overlay.search.view-title',
    defaultMessage: 'Search',
  },
  readMore: {
    id: 'mobile-overlay.video-description.read-more',
    defaultMessage: 'Read More',
  },
  readLess: {
    id: 'mobile-overlay.video-description.read-less',
    defaultMessage: 'Read Less',
  },
  mobileCrew: {
    id: 'mobile-overlay.video-description.crew',
    defaultMessage: 'Crew',
  },
  mobileCast: {
    id: 'mobile-overlay.video-description.cast',
    defaultMessage: 'Cast',
  },
  metadataTitle: {
    id: 'mobile-overlay.video.metadata-title',
    defaultMessage: 'Video Metadata',
  },
  descriptionTitle: {
    id: 'mobile-overlay.video.description-title',
    defaultMessage: 'Video Description',
  },
  moreOnChannelTitle: {
    id: 'mobile-overlay.video.more-on-channel-title',
    defaultMessage: 'More on this channel',
  },
  mobileProceedPaypal: {
    id: 'widget.payments-mobile.proceed-paypal',
    defaultMessage: 'Proceed with PayPal →',
  },
  mobileProceedCashier: {
    id: 'widget.payments-mobile.proceed-cashier',
    defaultMessage: 'Select a payment method',
  },
  mobilePurchase: {
    id: 'widget.payments-mobile.purchase',
    defaultMessage: 'Purchase {price}',
  },
  mobileRent: {
    id: 'widget.payments-mobile.rent',
    defaultMessage: 'Rent {price}',
  },
  mobileSubscriptionMonth: {
    id: 'widget.payments-mobile.subscription-month',
    defaultMessage: 'Subscription {price}/month',
  },
  mobileOnePayment: {
    id: 'widget.payments-mobile.one-payment',
    defaultMessage: 'One time payment',
  },
  mobileMonthlyPayment: {
    id: 'widget.payments-mobile.monthly-payment',
    defaultMessage: 'Recurring monthly payments (cancel anytime)',
  },
  mobileUnlimitedStreaming: {
    id: 'widget.payments-mobile.unlimitedStreaming',
    defaultMessage: 'Unlimited streaming',
  },
  mobileInstantAccess: {
    id: 'widget.payments-mobile.instant-access',
    defaultMessage: 'Instant access to new videos',
  },
  mobileSingleVideo: {
    id: 'widget.payments-mobile.single-video',
    defaultMessage: '1 video',
  },
  mobileSingleVideoStreaming: {
    id: 'widget.payments-mobile.single-video-streaming',
    defaultMessage: '1 video streaming',
  },
  mobileStreamingPeriod: {
    id: 'widget.payments-mobile.streaming-period',
    defaultMessage: '{period} hours streaming period starts when you hit the "play" button',
  },
  mobilePaymentSignIn: {
    id: 'widget.payments-mobile.sign-in',
    defaultMessage: 'Sign in',
  },
  mobileSignUp: {
    id: 'widget.payments-mobile.sign-up',
    defaultMessage: 'Sign up →',
  },
  mobileSignInToComplete: {
    id: 'widget.payments-mobile.sign-in-to-complete',
    defaultMessage: 'Sign up to complete your purchase',
  },
  mobileLogout: {
    id: 'widget.payments-mobile.logout',
    defaultMessage: 'Log out',
  },
  mobileHaveAccount: {
    id: 'widget.payments-mobile.have-account',
    defaultMessage: 'Already have an account?',
  },
  mobileReadyAction: {
    id: 'widget.payments-mobile.ready-action',
    defaultMessage: 'Proceed to Checkout',
  },
  mobileSignedAs: {
    id: 'widget.payments-mobile.signed-as',
    defaultMessage: 'You are signed in as:',
  },
  mobileNotYourAccount: {
    id: 'widget.payments-mobile.not-your-account',
    defaultMessage: 'Not your account?',
  },
  mobileMemberOnlyBenefits: {
    id: 'widget.payments-mobile.member-only-benefits',
    defaultMessage: 'Here’s what you’ll get:',
  },
  mobileSignUpToWatch1: {
    id: 'widget.payments-mobile.sign-up-to-watch-1',
    defaultMessage: 'Sign up to watch this video.',
  },
  mobileSignUpToWatch2: {
    id: 'widget.payments-mobile.sign-up-to-watch-2',
    defaultMessage: 'It’ll only take a sec.',
  },
  mobileConfirmAndPay: {
    id: 'widget.payments-mobile.confirm-and-pay',
    defaultMessage: 'Confirm and Pay',
  },
  mobileReload: {
    id: 'widget.payments-mobile.reload-button',
    defaultMessage: 'Reload',
  },
  closePurchase: {
    id: 'widget.payments-mobile.a11y.close-purchase',
    defaultMessage: 'Close purchase dialog',
  },
  closeSubscribe: {
    id: 'widget.payments-mobile.a11y.close-subscribe',
    defaultMessage: 'Close subscribe dialog',
  },
  videoMetaDuration: {
    id: 'widget.a11y.video.duration',
    defaultMessage: 'Duration: {value}',
  },
  videoMetaGenre: {
    id: 'widget.a11y.video.genre',
    defaultMessage: 'Genre: {name}',
  },
  videoMetaPublishedBy: {
    id: 'widget.a11y.video.published-by',
    defaultMessage: 'Published by {name}',
  },
  thankForPurchase: {
    id: 'widget.payments.thank-for-purchase',
    defaultMessage: 'Thank you for your purchase!',
  },
  thankForPurchaseShort: {
    id: 'widget.payments.thank-for-purchase-short',
    defaultMessage: 'Thanks for your purchase!',
  },
  videoWillBeAvailable: {
    id: 'widget.payments.video-will-be-available',
    defaultMessage: 'Your video will be available in a few minutes. You\'ll receive a confirmation email when your payment has been processed.',
  },
  goToVideo: {
    id: 'widget.payments.go-to-video',
    defaultMessage: 'Go to video',
  },
});



// WEBPACK FOOTER //
// ./src/messages/widget.js